import { toast } from 'react-toastify';
import { NxtbnDrawer } from '../../components';
// import ReceiveInventory from './receiveInventory';
// import PurchaseEdit from './PurchaseEdit';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import GenericSelectableTable from '../selectableTable';
import moment from 'moment';

const GET_CART_DETAILS = gql`
    query GetCartDetails($id: ID!) {
        cartByUser(userId: $id) {
            abandonedAt
            dbId
            user {
                fullName
                email
            }
            items {
                dbId
                quantity
                variant {
                    name
                    price
                }
            }
        }
    }
`;



interface StockDetailsViewProps{
    instance: any;
    isOpen: boolean;
    onClose: ()=>void;
    refresh: ()=>void;
}

function CartDetailsView({instance, isOpen, onClose, refresh}:StockDetailsViewProps) {
    const { data, loading, error, refetch } = useQuery(GET_CART_DETAILS, {
        variables: { id: instance },
        notifyOnNetworkStatusChange: true,
      });

      const columns = [
        { header: "ID", key: "node.dbId", render:(item:any)=>(
          <div className="text-base-300 text-sm">
            #ID {item.dbId}
          </div>
        )},
        { header: "Variant", key: "variant.name", },
        { header: "Price", key: "variant.price", },
        { header: "quantity", key: "quantity", },    
      ]
      const bullkActionButtons = [
        {
          label: 'Export Selected',
          onClick: (selectedItems:any) => {
            toast.success(`Export items: ${Array.from(selectedItems)}`);
            // Implement export logic here
          },
        },
      ];
  
  return (
    <NxtbnDrawer isOpen={isOpen} onClose={onClose} title='Stock Transfer Detail'>
       

        <div className="p-4">
            <div className="flex justify-between items-center">
                <div className="text-base-300 text-sm">
                    <span className="text-base-400">Abandoned At:</span> {moment(data?.cartByUser.abandonedAt).fromNow()}  
                </div>
                <div className="text-base-300 text-sm">
                    <span className="text-base-400">User:</span> {data?.cartByUser.user.fullName}
                </div>
            </div>
            <GenericSelectableTable columns={columns} data={data?.cartByUser?.items || []} bullkActionButtons={bullkActionButtons}/>
            
        </div>

        
    </NxtbnDrawer>
  )
}

export default CartDetailsView